export default String.raw`
{% assign topBannerSize = config.Banners['top'].Images | Size -%}

{% if topBannerSize > 0 -%}
    {% assign topBanner = config.Banners['top'].Images[0] -%}
    {% assign bannerText = topBanner.Text -%}
    
    {% if bannerText == '' -%}
        {% assign firstPage = topBanner.Pages | First -%}
        {% if firstPage != null and firstPage.Name != null and firstPage.Name != '' -%}
            {% assign bannerText = firstPage.Name -%}
        {% endif -%}
    {% endif -%}

    {% if bannerText != '' -%}
        {% assign settingsJSON = topBanner.Settings | H -%}
        {% assign pagesCount = topBanner.Pages | Size -%}
        
        {% capture timer -%}
            {% if settingsJSON contains 'timerDateTo' -%}
                <span class="header-top-banner__countdown-timer"
                    data-translation-days="{{translations.TimerLabelDays | H}}"
                    data-translation-hours="{{translations.TimerLabelHours | H}}"
                    data-translation-minutes="{{translations.TimerLabelMinutes | H}}"
                    data-translation-seconds="{{translations.TimerLabelSeconds | H}}"
                    style="visibility: hidden; opacity: 0;{% if settingsJSON contains '&quot;timerDateTo&quot;:&quot;&quot;' %} display: none;{% endif %}">
                    0 {{translations.TimerLabelDays}} 0 {{translations.TimerLabelHours}} 0 {{translations.TimerLabelMinutes}} 0 {{translations.TimerLabelSeconds}}
                </span>
            {% endif -%}
        {% endcapture -%}

        {% capture textContent -%}
            <p class="header-top-banner__text" title="{{ bannerText | H }}">
                <span class="header-top-banner__text-content">{{ bannerText | H }}</span>
                {{ timer }}
            </p>
        {% endcapture -%}

        <div class="header-top-banner" id="topBanner" data-settings='{{topBanner.Settings | H}}'>
            {% if topBanner.Link != '' -%}
                {% capture link -%}{% include 'partials/common/user-link.html', userLink: topBanner.Link -%}{% endcapture -%}

                {% if topBanner.Pages[0].Name != null and topBanner.Pages[0].Name != '' -%}
                    {% assign hasEmptyPageName = false -%}
                {% else -%}
                    {% assign hasEmptyPageName = true -%}
                {% endif -%}

                {% if topBanner.Text != '' and hasEmptyPageName -%}
                    <a class="header-top-banner__content" 
                       href="{{ link }}" 
                       target="{% if topBanner.TargetBlank %}_blank{% else %}_self{% endif %}"
                       {% if topBanner.TargetBlank %}rel="noopener noreferrer"{% endif %}>
                        {{ textContent }}
                    </a>
                {% elsif topBanner.Text == '' and pagesCount < 2 and topBanner.Pages[0].Name != '' -%}
                    <a class="header-top-banner__content" 
                       href="{{ link }}" 
                       target="{% if topBanner.TargetBlank %}_blank{% else %}_self{% endif %}"
                       {% if topBanner.TargetBlank %}rel="noopener noreferrer"{% endif %}>
                        {{ textContent }}
                    </a>
                {% else -%}
                    <div class="header-top-banner__content header-top-banner__content--links {% if pagesCount > 3 and topBanner.Text == '' -%}header-top-banner__content--justify{% endif -%} swiper">
                        <div class="swiper-wrapper">
                            {% if topBanner.Text != '' -%}
                                {% assign pages = topBanner.Pages | Take: 4 -%}
                                <div class="header-top-banner__text-wrapper cls-fix swiper-slide">
                                    {{ textContent }}
                                </div>
                            {% else -%}
                                {% assign pages = topBanner.Pages | Take: 6 -%}
                            {% endif -%}

                            {% assign topBannerBase = page.BaseHref -%}
                            {% for page in pages -%}
                                {% if page.Name != null and page.Name != '' -%}
                                    <div class="header-top-banner__link-wrapper cls-fix swiper-slide">
                                        {% if page.Url == null or page.Url == '' -%}
                                            <div class="header-top-banner__link" title="{{ page.Name | H }}">{{ page.Name | H }}</div>
                                        {% else -%}
                                            {% capture pageUrl -%}{% include 'partials/common/user-link.html', userLink: page.Url, userBase: topBannerBase -%}{% endcapture -%}
                                            <a class="header-top-banner__link" 
                                               href="{{pageUrl}}" 
                                               target="{% if page.TargetBlank %}_blank{% else %}_self{% endif %}" 
                                               title="{{ page.Name | H }}"
                                               {% if page.TargetBlank %}rel="noopener noreferrer"{% endif %}>
                                                {{ page.Name | H }}
                                            </a>
                                        {% endif -%}
                                    </div>
                                {% endif -%}
                            {% endfor -%}
                        </div>
                    </div>
                {% endif -%}
            {% else -%}
                <div class="header-top-banner__content">
                    <div class="header-top-banner__text-wrapper">
                        {{ textContent }}
                    </div>
                </div>
            {% endif -%}
        </div>
    {% endif -%}
{% endif -%}

<header class="header header-js">
    {% if __actionGET -%}
        <script>
            $(document).ready(function() {
                var message = '{{__actionGET.Message}} {{__actionGET.Description}}';
                var type = '{{__actionGET.Type}}';
                app.temporaryPopupMessage(undefined, message, type);
            });
        </script>
    {% endif -%}
    
    {% if page.PageId != config.DefinedPages.Login.Id and page.PageId != config.DefinedPages.CustomerProfile.Id and page.PageId != config.DefinedPages.Order.Id -%}
        {% include 'partials/common/login.html' -%} 
    {% endif -%}

    {% if usr.Authenticated == false and config.AuthenticatedOnly == false -%}
        {% assign notAuth = true -%}
    {% endif -%}

    {% include 'partials/common/header/header-top-bar.html' -%}

    <div class="header__main header-main-js {% unless usr.Authenticated or notAuth -%} closed {% endunless -%}">
        <div class="header__logo">
            <a href="{{ page.BaseHref }}{{ config.DefinedPages.Home.Url | Replace: '^\./', '' }}" aria-label="{{ config.DefinedPages.Home.Name }} - {{ config.Shop.Name }}">
                <img src="{{config.Shop.ImageUrl}}" alt="{{ config.Shop.Name }}" loading="eager" fetchpriority="high">
            </a>
        </div>
        {% unless __consents -%}
            <button aria-label="{{ translations.Menu }}" class="header__menu header-menu-js">
                <svg height="32" width="32">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bars-{{settings.iconStyle}}"></use>
                </svg>
            </button>
            <div class="header__sidebar hide none header-sidebar-js header-menu-sidebar-js">
                <div class="header__sidebar-content left hide header-sidebar-content-js header-menu">
                    <div class="header__sidebar-header">
                        <div class="header__sidebar-name">
                            {{ translations.Menu }}
                        </div>
                        <button class="header__sidebar-closer header-sidebar-closer-js" aria-label="{{ translations.Close }}">
                            <svg aria-hidden="true">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                            </svg>
                        </button>
                    </div>
                    <div class="header-menu__content header-menu-content-js">
                        <div class="header-menu__contact">
                            {% if usr.Authenticated and customer.Supervisor -%}
                                <div>
                                    <div class="header-menu__item supervisor header-menu-supervisor-js">
                                        <svg height="24" width="24">
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dots-{{settings.iconStyle}}"></use>
                                        </svg>
                                        <span>{{ translations.ContactSupervisor }}</span>
                                    </div>

                                    <div class="header-menu__box-supervisor header-menu-box-supervisor-js" style="display: none;">
                                        <div>{{ customer.Supervisor.FirstName }} {{ customer.Supervisor.LastName }}</div>
                                        <div>
                                            {% if customer.Supervisor.PhoneNo != '' -%}
                                                <a href="tel:{{ customer.Supervisor.PhoneNo }}" title="{{ translations.Call }}" class="header-menu__item text">
                                                    <svg height="24" width="24">
                                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
                                                    </svg>
                                                    <span>{{ customer.Supervisor.PhoneNo }}</span>
                                                </a>
                                            {% endif -%}
                                        </div>
                                        <div>
                                            {% if customer.Supervisor.Email != '' -%}
                                                <a href="mailto:{{ customer.Supervisor.Email }}" class="header-menu__item text">
                                                    <svg height="24" width="24">
                                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
                                                    </svg>
                                                    <span>{{ customer.Supervisor.Email }}</span>
                                                </a>
                                            {% endif -%}
                                        </div>
                                    </div>
                                </div>
                            {% else -%}
                                {% if config.Shop.Contact.PhoneNo != '' -%}
                                    <a href="tel:{{ config.Shop.Contact.PhoneNo }}" class="header-menu__item" title="{{ translations.Call }}">
                                        <svg height="24" width="24">
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
                                        </svg>
                                        <span>{{ config.Shop.Contact.PhoneNo }}</span>
                                    </a>
                                {% endif -%}

                                {% if config.Shop.Contact.Email != '' -%}
                                    <a href="mailto:{{ config.Shop.Contact.Email }}" class="header-menu__item" title="{{ translations.WriteToUs }}">                 
                                        <svg height="24" width="24">
                                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
                                        </svg>
                                        <span>{{ config.Shop.Contact.Email }}</span>
                                    </a>
                                {% endif -%}
                            {% endif -%}


                        </div>
                    </div>
                </div>
            </div>
        {% endunless -%}
        {% if usr.Authenticated or notAuth -%}
            {% unless __consents -%}
                <div class="form-js header__search quick-search-form-js {% if settings.autofill == 'yes' %} autocomplete-form-js {% endif -%}">
                    <input type="hidden" name="__action" value="Get/Search">
                    <input placeholder="{{ translations.SearchArticleDots }}" aria-label="{{ translations.SearchArticleDots }}" type="search" class="header__search-input hide-mobile-placeholder header-search-input-js" value="" name="search" maxlength="100" {% if settings.autofill == 'yes' %} autocomplete="one-time-code" data-max-autocomplete-products="{{settings.autofillQuantity}}" {% endif -%} >
                    <svg tabindex="0" role="button" class="header__search-closer header-autocomplete-closer-js hidden-js" aria-label="{{ translations.Delete }}">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                    </svg>
                    <button class="header__btn header__search-btn quick-search-js enter-key-trigger-js" title="{{ translations.Search }}" aria-label="{{ translations.Search }}">
                        <svg height="24" width="24">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#search-{{settings.iconStyle}}"></use>
                        </svg>
                    </button>
                </div>
                <div class="header-client-area client-area-js" data-cart-url="{{ page.BaseHref }}{{config.DefinedPages.Order.Url}}">
                    {% include 'partials/common/header/client-area.html' -%}
                </div>
            {% endunless -%}
        {% endif -%}

        {% assign msgCounterH = 0 -%}
        {% for msg in config.Messages -%}
            {% assign msgCounterH = msgCounterH | Plus: 1 -%}
            {% if msg.Type == 0 -%}
                {% include 'partials/common/cookies-message.html', msgCounter: msgCounterH -%}
            {% endif -%}
        {% endfor -%}

        {% unless __consents -%}
            {% include 'partials/common/navigation-bars/main-navigation-bar-partial.html' -%}
            <div class="header__sidebar hide none header-sidebar-js header-categories-sidebar-js">
                <div class="header__sidebar-content header__categories left hide header-sidebar-content-js header-category-column-js">
                    {% assign url = '' -%}
                    {% assign groupId = 0 -%}

                    <div class="header__sidebar-header">
                        <button class="header-categories__btn menu categories-menu-level-js">
                            <svg>
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                            </svg>
                            {{translations.Menu}}
                        </button>
                        <button class="header-categories__btn categories-first-level-js" data-id="0" style="display: none;">
                            <svg>
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                            </svg>
                            {{translations.Categories}}
                        </button>
                        <button class="header__sidebar-closer header-sidebar-closer-js" aria-label="{{ translations.Close }}">
                            <svg aria-hidden="true">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                            </svg>
                        </button>
                        <div class="header__search header__categories-search header-categories-search-js">
                            <input type="search" name="search-categories" aria-label="{{ translations.SearchCategories }}" class="header__search-input" placeholder="{{ translations.SearchCategories }}" >
                            <svg tabindex="0" role="button" class="header__search-closer header-categories-search-closer-js hidden-js" aria-label="{{ translations.Delete }}">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                            </svg>
                            <button class="header__btn header__search-btn header-categories-search-btn-js" title="{{ translations.Search }}" aria-label="{{ translations.Search }}">
                                <svg height="24" width="24">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#search-{{settings.iconStyle}}"></use>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div tabindex="-1" class="header-categories" data-start-id="{{groupId}}" data-lang="{{page.LanguageId}}" data-start-url="{{url}}" data-start-has-children="{{page.CurrentSiteNode.HasChildren}}">
                        <div class="header-categories__sliding sliding-categories-js">
                            <script>
                                $(document).ready(function() {
                                    if($('.prev-buttons-js').is(':last-child')){
                                        $('.prev-buttons-js .prev-level-js').trigger('click');
                                    }
                                });
                            </script>
                            {% for category in header.Nodes -%}
                                {% assign categoryGroupId = category.Id | Split: ',' | Last -%}
                                {% assign hasNodes = category.Groups | Size -%}
                                <div class="header-categories__item header-categories-item-js first-level-category-js {% if hasNodes > 0 -%} has-nodes-js {% endif %} {% if groupId != 0 -%} hidden-js {% endif %}" data-name="{{category.Name}}">
                                    {% assign categoryUrl = category.Url -%}
                                    <a class="header-categories__link" href="{{ page.BaseHref }}{{ categoryUrl }}">{{ category.Name }}</a>
                                    {% if hasNodes > 0 -%}
                                        <button class="header-categories__arrow next-level-js" aria-label="{{ translations.GoNext }}" data-id="{{categoryGroupId}}" data-name="{{category.Name}}">
                                            <svg>
                                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                                            </svg>
                                        </button>
                                    {% endif -%}
                                </div>
                            {% endfor -%}
                        </div>
                    </div>
                </div>
            </div>
        {% endunless -%}
    </div>
    {% if page.PageId == config.DefinedPages.ProductDetails.Id -%}
        {% include 'partials/product/comparison/comparison-bar.html' -%}
    {% endif -%}
</header>

<div class="page-padding">
    {% if page.PageId != config.DefinedPages.Home.Id and page.PageId != config.DefinedPages.Blog.Id and page.PageId != config.DefinedPages.Order.Id -%}
        {% include 'partials/common/breadcrumbs.html' -%}
    {% endif -%}
</div>
`